import Autolinker from 'autolinker';
import { markify } from '@threema/threema-markup';
import { escapeRegExp, filter, hasValue } from './helpers';
import { emojify } from './helpers/emoji';
angular.module('3ema.filters', [])
    .filter('escapeHtml', function () {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
    };
    return (text) => {
        if (text === undefined || text === null) {
            text = '';
        }
        return text.replace(/[&<>"']/g, (m) => map[m]);
    };
})
    .filter('nlToBr', function () {
    return (text, enabled) => {
        if (enabled || enabled === undefined) {
            text = text.replace(/\n/g, '<br>');
        }
        return text;
    };
})
    .filter('emptyToPlaceholder', function () {
    return (text, placeholder = '-') => {
        if (text === null || text === undefined || text.trim().length === 0) {
            return placeholder;
        }
        return text;
    };
})
    .filter('linkify', function () {
    const autolinker = new Autolinker({
        newWindow: true,
        stripPrefix: false,
        stripTrailingSlash: false,
        truncate: 99999,
        className: 'autolinked',
        urls: true,
        email: true,
        phone: false,
        mention: false,
        hashtag: false,
    });
    return (text) => autolinker.link(text);
})
    .filter('emojify', () => emojify)
    .filter('markify', () => markify)
    .filter('mentionify', [
    'WebClientService',
    '$translate',
    'escapeHtmlFilter',
    function (webClientService, $translate, escapeHtmlFilter) {
        return (text) => {
            if (text !== null && text.length > 10) {
                let result = text.match(/@\[([\*\@a-zA-Z0-9][\@a-zA-Z0-9]{7})\]/g);
                if (result !== null) {
                    result = new Set(result);
                    for (const possibleMention of result) {
                        const identity = possibleMention.substr(2, 8);
                        let mentionName;
                        let cssClass;
                        if (identity === '@@@@@@@@') {
                            mentionName = $translate.instant('messenger.ALL');
                            cssClass = 'all';
                        }
                        else if (identity === webClientService.me.id) {
                            mentionName = webClientService.me.displayName;
                            cssClass = 'me';
                        }
                        else {
                            const contact = webClientService.contacts.get(possibleMention.substr(2, 8));
                            if (contact !== null && contact !== undefined) {
                                cssClass = 'id ' + identity;
                                mentionName = contact.displayName;
                            }
                        }
                        if (mentionName !== undefined) {
                            text = text.replace(new RegExp(escapeRegExp(possibleMention), 'g'), '<span class="mention ' + cssClass + '"'
                                + ' text="@[' + identity + ']">' + escapeHtmlFilter(mentionName) + '</span>');
                        }
                    }
                }
            }
            return text;
        };
    },
])
    .filter('reverse', function () {
    return (list) => list.slice().reverse();
})
    .filter('hasData', function () {
    return function (obj, receivers) {
        const valid = (receiver) => receivers.get(receiver.type).has(receiver.id);
        return filter(obj, valid);
    };
})
    .filter('hasContact', function () {
    return function (obj, contacts) {
        const valid = (item) => contacts.has(item.id);
        return filter(obj, valid);
    };
})
    .filter('duration', function () {
    return function (seconds) {
        const left = Math.floor(seconds / 60);
        const right = seconds % 60;
        const padLeft = left < 10 ? '0' : '';
        const padRight = right < 10 ? '0' : '';
        return padLeft + left + ':' + padRight + right;
    };
})
    .filter('mapLink', function () {
    return function (location) {
        return 'https://www.openstreetmap.org/?mlat='
            + location.lat + '&mlon='
            + location.lon;
    };
})
    .filter('messageStateIcon', function () {
    return (message) => {
        if (!message) {
            return '';
        }
        if (!message.isOutbox) {
            switch (message.state) {
                case 'user-ack':
                    return 'thumb_up';
                case 'user-dec':
                    return 'thumb_down';
                default:
                    return 'reply';
            }
        }
        switch (message.state) {
            case 'pending':
            case 'sending':
                return 'file_upload';
            case 'sent':
                return 'email';
            case 'delivered':
                return 'move_to_inbox';
            case 'read':
                return 'visibility';
            case 'send-failed':
                return 'report_problem';
            case 'user-ack':
                return 'thumb_up';
            case 'user-dec':
                return 'thumb_down';
            default:
                return '';
        }
    };
})
    .filter('messageStateTitleText', ['$translate', function ($translate) {
        return (message) => {
            if (!message) {
                return null;
            }
            if (!message.isOutbox) {
                switch (message.state) {
                    case 'user-ack':
                        return 'messageStates.WE_ACK';
                    case 'user-dec':
                        return 'messageStates.WE_DEC';
                    default:
                        return 'messageStates.UNKNOWN';
                }
            }
            switch (message.state) {
                case 'pending':
                    return 'messageStates.PENDING';
                case 'sending':
                    return 'messageStates.SENDING';
                case 'sent':
                    return 'messageStates.SENT';
                case 'delivered':
                    return 'messageStates.DELIVERED';
                case 'read':
                    return 'messageStates.READ';
                case 'send-failed':
                    return 'messageStates.FAILED';
                case 'user-ack':
                    return 'messageStates.USER_ACK';
                case 'user-dec':
                    return 'messageStates.USER_DEC';
                default:
                    return 'messageStates.UNKNOWN';
            }
        };
    }])
    .filter('fileSize', function () {
    return (size) => {
        if (!size) {
            return '';
        }
        const i = Math.floor(Math.log(size) / Math.log(1024));
        const x = (size / Math.pow(1024, i)).toFixed(2);
        return (x + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]);
    };
})
    .filter('mimeTypeLabel', ['MimeService', function (mimeService) {
        return (mimeType) => mimeService.getLabel(mimeType);
    }])
    .filter('mimeTypeIcon', ['MimeService', function (mimeService) {
        return (mimeType) => mimeService.getIconUrl(mimeType);
    }])
    .filter('idsToNames', ['WebClientService', '$filter', function (webClientService, $filter) {
        return (ids, sort = false) => {
            const names = [];
            for (const id of ids) {
                const contactReceiver = webClientService.contacts.get(id);
                if (hasValue(contactReceiver)) {
                    names.push($filter('displayName')(contactReceiver));
                }
                else {
                    names.push('Unknown');
                }
            }
            return sort ? names.sort().join(', ') : names.join(', ');
        };
    }])
    .filter('unixToTimestring', ['$translate', function ($translate) {
        function formatTime(date) {
            return ('00' + date.getHours()).slice(-2) + ':' +
                ('00' + date.getMinutes()).slice(-2);
        }
        function formatMonth(num) {
            switch (num) {
                case 0x0:
                    return 'date.month_short.JAN';
                case 0x1:
                    return 'date.month_short.FEB';
                case 0x2:
                    return 'date.month_short.MAR';
                case 0x3:
                    return 'date.month_short.APR';
                case 0x4:
                    return 'date.month_short.MAY';
                case 0x5:
                    return 'date.month_short.JUN';
                case 0x6:
                    return 'date.month_short.JUL';
                case 0x7:
                    return 'date.month_short.AUG';
                case 0x8:
                    return 'date.month_short.SEP';
                case 0x9:
                    return 'date.month_short.OCT';
                case 0xa:
                    return 'date.month_short.NOV';
                case 0xb:
                    return 'date.month_short.DEC';
            }
        }
        function isSameDay(date1, date2) {
            return date1.getFullYear() === date2.getFullYear()
                && date1.getMonth() === date2.getMonth()
                && date1.getDate() === date2.getDate();
        }
        return (timestamp, forceFull = false) => {
            const date = new Date(timestamp * 1000);
            const now = new Date();
            if (!forceFull && isSameDay(date, now)) {
                return formatTime(date);
            }
            const yesterday = new Date(now);
            yesterday.setDate(now.getDate() - 1);
            if (!forceFull && isSameDay(date, yesterday)) {
                return $translate.instant('date.YESTERDAY') + ', ' + formatTime(date);
            }
            let year = '';
            if (forceFull || date.getFullYear() !== now.getFullYear()) {
                year = ' ' + date.getFullYear();
            }
            return date.getDate() + '. '
                + $translate.instant(formatMonth(date.getMonth()))
                + year + ', '
                + formatTime(date);
        };
    }])
    .filter('unsafeResUrl', ['$sce', function ($sce) {
        return $sce.trustAsResourceUrl;
    }])
    .filter('displayName', ['WebClientService', '$translate',
    function (webClientService, $translate) {
        return function (contact) {
            if (contact.id === webClientService.me.id) {
                return $translate.instant('messenger.ME');
            }
            else {
                return contact.displayName;
            }
        };
    }])
    .filter('strengthToColor', [function () {
        return function (strength) {
            switch (strength) {
                case "strong":
                    return '#05a63f';
                case "good":
                    return '#cddc39';
                case "weak":
                    return '#ff9800';
                case "bad":
                default:
                    return '#f44336';
            }
        };
    }]);
